var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #3fc6f0;\n      }\n\n      .cls-3 {\n        fill: #e7f6fc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.1,
    cy: 48,
    r: 7.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.1,64.3c-22.5,0-40-7.2-40-16.4s17.6-16.4,40-16.4,40,7.2,40,16.4-17.6,16.4-40,16.4ZM42.1,35.1c-21.5,0-36.6,6.8-36.6,12.9s15,12.9,36.6,12.9,36.6-6.8,36.6-12.9-15-12.9-36.6-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.1,83.7c-3.5,0-7.8-1.9-12.5-5.7-6.2-5-12.4-12.8-17.7-21.8-5.2-9-8.8-18.3-10-26.2-1.3-8.4,0-14.3,4.2-16.7,8-4.6,23,7.1,34.2,26.5h0c5.2,9,8.8,18.3,10,26.2,1.3,8.4,0,14.3-4.2,16.7-1.2.7-2.6,1-4,1ZM26.1,15.8c-.9,0-1.6.2-2.3.6-2.7,1.5-3.6,6.3-2.5,13.1,1.2,7.4,4.6,16.3,9.6,25s11,16.1,16.8,20.8c5.3,4.3,9.9,5.9,12.6,4.4s3.6-6.3,2.5-13.1c-1.2-7.4-4.6-16.3-9.6-25h0c-9.5-16.4-20.9-25.8-27.2-25.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.2,83.7c-1.5,0-2.8-.3-4-1-4.1-2.3-5.5-8.3-4.2-16.7,1.3-7.9,4.8-17.2,10-26.2,11.2-19.4,26.2-31.1,34.2-26.5,7.9,4.6,5.4,23.4-5.8,42.9h0c-5.2,9-11.5,16.8-17.7,21.8-4.7,3.8-8.9,5.7-12.5,5.7ZM58.1,15.8c-6.2,0-17.7,9.4-27.2,25.8-5,8.7-8.4,17.6-9.6,25-1.1,6.8-.2,11.6,2.5,13.1s7.3,0,12.6-4.4c5.8-4.8,11.8-12.1,16.8-20.8,10.8-18.7,12.4-35.1,7.1-38.1-.6-.4-1.4-.6-2.3-.6h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/React.656f3183ae42122143fc60c6d12d2af3.svg";
export { ForwardRef as ReactComponent };